module.exports = __webpack_public_path__ + "files/bdd0d5e034ab4a8641bd05736d5ed84f.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Size1-Regular.woff
// module id = 828
// module chunks = 60